<template>
   <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Lista</h6>
    </div>
    <div class="card-body">
      <div v-if="listaObjeto.length ==  0">Nenhum item encontrado</div>
      <div
        class="table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
        style="max-height:500px; overflow-y: auto"
        v-else
      >
      <div class="list-group" v-show="listaObjeto.length > 0">
        <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="(obj, i) in listaObjeto" v-bind:key="i">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{obj.sigla_entidade}}</h5>
          </div>
          <a v-for="(link, k) in obj.listaLink" v-bind:key="k" :href="link.link" target="_blank"><p class="mb-1 text-blue" >{{link.nome_link}}</p></a>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import http from "./../../../axios";

export default {
  name: "LinkUteisListaDetalhada",
  data() {
    return {
      listaObjeto: [],
      objeto: {},
      tokens: {}
    };
  },
  created: function() {
    this.getTokens();
    this.getListaObjeto();
  },
  methods: {
    getListaObjeto: function() {
      this.$Progress.start();
      this.listaObjeto = [];
      http
        .get(`/api/linkuteisentidade/cooperado/${this.tokens.id}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaObjeto = r.data.result;
          } else {
            this.listaObjeto = [];
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/linkUteis/LinkUteisListaDetalhada.vue